module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.label ? 'vf-labeled' : ''
  }, [_vm._t("default"), _vm._v(" "), (_vm.label) ? _c('label', [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), (_vm.type === 'text' || _vm.type === 'email') ? _c('div', [(_vm.mask) ? _c('vue-masked-input', {
    staticClass: "form-control",
    attrs: {
      "mask": _vm.mask,
      "type": _vm.type,
      "name": _vm.name,
      "placeholder": _vm.placeholder
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', _vm.maskedInput)
      }
    },
    model: {
      value: (_vm.maskedInput),
      callback: function($$v) {
        _vm.maskedInput = $$v
      },
      expression: "maskedInput"
    }
  }) : _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": _vm.type,
      "name": _vm.name,
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', $event.target.value)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'password') ? _c('vue-password', {
    attrs: {
      "placeholder": _vm.placeholder,
      "score": _vm.passwordScore
    },
    on: {
      "input": _vm.updateScore
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }) : _vm._e(), _vm._v(" "), _c('field-messages', {
    attrs: {
      "state": _vm.formstate,
      "name": _vm.name,
      "show": "$touched || $submitted"
    }
  }, [
    [_c('span', {
      staticClass: "glyphicon glyphicon-ok form-control-feedback"
    })], _vm._v(" "), _vm._l((_vm.messages), function(message, key) {
      return _c('template', {
        slot: key
      }, [_c('div', {
        key: key
      }, [_c('span', {
        staticClass: "glyphicon glyphicon-remove form-control-feedback"
      }), _vm._v(" "), _c('span', {
        staticClass: "has-error"
      }, [_vm._v(_vm._s(message))])])])
    }), _vm._v(" "), _c('template', {
      slot: 'notStrong'
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-remove form-control-feedback"
    }), _vm._v(" "), _vm._l((_vm.suggestions), function(suggestion, key) {
      return _c('div', {
        key: key
      }, [_c('span', {
        staticClass: "glyphicon glyphicon-remove form-control-feedback"
      }), _vm._v(" "), _c('span', {
        staticClass: "has-error"
      }, [_vm._v(_vm._s(suggestion))])])
    })], 2)
  ], 2)], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-de18a73a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-de18a73a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utilities/VueFormInput.vue
// module id = 2389
// module chunks = 0